<body *ngIf="isVisible" appCloseOnEscape (onEscape)="toggleVisible()">
  <div class="header">
    <label class="title">{{'chat.assistant' | transloco }}</label>
    <button class="close" title="Закрыть" (click)="toggleVisible()"></button>
  </div>
  <hr class="separate-block" />
  <div #chatBody class="chat-body">
    <div style="width: 100%;" *ngFor="let message of historyMessages">

      <div *ngIf="message.role === 'assistant'">
        <div class="request">
          <div class="message recieved">
            <p [innerHTML]="message.content"></p>
          </div>
          <p class="time">{{ message.time | date:'HH:mm' }}</p>
        </div>
      </div>

      <div *ngIf="message.role === 'user'">
        <div class="request user">
          <p class="time">{{ message.time | date:'HH:mm' }}</p>
          <div class="message sent">
            <p [innerHTML]="message.content"></p>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading message recieved">
      <app-loading-chat></app-loading-chat>
    </div>
  </div>
  <hr class="separate-block" />

  <div class="user-message">
    <textarea [(ngModel)]="message" placeholder="{{'chat.inputMessage' | transloco }}"
              (keydown.enter)="sendMessage($event)"></textarea>
    <button class="send-message" (click)="sendMessage()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.50929 4.23013L18.0693 8.51013C21.9093 10.4301 21.9093 13.5701 18.0693 15.4901L9.50929 19.7701C3.74929 22.6501 1.39929 20.2901 4.27929 14.5401L5.14929 12.8101C5.36929 12.3701 5.36929 11.6401 5.14929 11.2001L4.27929 9.46013C1.39929 3.71013 3.75929 1.35013 9.50929 4.23013Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path opacity="0.5" d="M5.43945 12H10.8395" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</body>

<body class="hidden" *ngIf="!isVisible">
  <button class="open" (click)="toggleVisible()"></button>
</body>
